var exports = {
  "LK": "CompanionRecords.module__sessionList___QjJWOX",
  "xJ": "CompanionRecords.module__transcriptList___QjJWOX",
  "c8": "CompanionRecords.module__speakerList___QjJWOX",
  "Vg": "CompanionRecords.module__sessionCard___QjJWOX",
  "Fb": "CompanionRecords.module__sessionButton___QjJWOX",
  "md": "CompanionRecords.module__detailHeading___QjJWOX",
  "ZW": "CompanionRecords.module__sessionSummary___QjJWOX",
  "Yj": "CompanionRecords.module__sessionExtras___QjJWOX",
  "Jm": "CompanionRecords.module__tagRow___QjJWOX",
  "uU": "CompanionRecords.module__tagPill___QjJWOX",
  "S": "CompanionRecords.module__sessionFooter___QjJWOX",
  "e6": "CompanionRecords.module__dateGroup___QjJWOX",
  "Tt": "CompanionRecords.module__dateGroupHeader___QjJWOX",
  "BL": "CompanionRecords.module__audioChip___QjJWOX",
  "J9": "CompanionRecords.module__audioChipButton___QjJWOX",
  "At": "CompanionRecords.module__audioChipWaveform___QjJWOX",
  "k$": "CompanionRecords.module__audioChipBar___QjJWOX",
  "fG": "CompanionRecords.module__audioChipBarPlayed___QjJWOX",
  "Dm": "CompanionRecords.module__audioChipDuration___QjJWOX",
  "vc": "CompanionRecords.module__audioChipError___QjJWOX",
  "fZ": "CompanionRecords.module__sessionTitleRow___QjJWOX",
  "pw": "CompanionRecords.module__detailMeta___QjJWOX",
  "I4": "CompanionRecords.module__transcriptMeta___QjJWOX",
  "U_": "CompanionRecords.module__sessionTime___QjJWOX",
  "kc": "CompanionRecords.module__detailTitle___QjJWOX",
  "Od": "CompanionRecords.module__statusBadge___QjJWOX",
  "nM": "CompanionRecords.module__detailContainer___QjJWOX",
  "Rm": "CompanionRecords.module__detailHeader___QjJWOX",
  "g4": "CompanionRecords.module__loadingContainer___QjJWOX",
  "xd": "CompanionRecords.module__detailSection___QjJWOX",
  "Gf": "CompanionRecords.module__sectionTitle___QjJWOX",
  "H9": "CompanionRecords.module__inlineEmpty___QjJWOX",
  "qg": "CompanionRecords.module__transcriptItem___QjJWOX",
  "$P": "CompanionRecords.module__speakerName___QjJWOX",
  "om": "CompanionRecords.module__speakerRole___QjJWOX",
  "KW": "CompanionRecords.module__transcriptText___QjJWOX",
  "B4": "CompanionRecords.module__speakerItem___QjJWOX",
  "ap": "CompanionRecords.module__speakerTone0___QjJWOX",
  "TP": "CompanionRecords.module__speakerTone1___QjJWOX",
  "aK": "CompanionRecords.module__speakerTone2___QjJWOX",
  "h3": "CompanionRecords.module__speakerTone3___QjJWOX",
  "av": "CompanionRecords.module__speakerTone4___QjJWOX",
  "VS": "CompanionRecords.module__speakerTone5___QjJWOX",
  "X9": "CompanionRecords.module__recordingPlayback___QjJWOX",
  "BJ": "CompanionRecords.module__recordingAudioPlayer___QjJWOX",
  "nj": "CompanionRecords.module__recordingPlaybackError___QjJWOX",
  "jy": "CompanionRecords.module__errorBanner___QjJWOX",
  "Uy": "CompanionRecords.module__spinningIcon___QjJWOX",
  "cd": "CompanionRecords.module__companion-record-spin___QjJWOX",
  "EG": "CompanionRecords.module__historyContainer___QjJWOX",
  "U5": "CompanionRecords.module__listToolbar___QjJWOX",
  "ZN": "CompanionRecords.module__recordingToolbar___QjJWOX",
  "hJ": "CompanionRecords.module__searchField___QjJWOX",
  "yW": "CompanionRecords.module__filterControl___QjJWOX",
  "t4": "CompanionRecords.module__listCaption___QjJWOX",
  "Km": "CompanionRecords.module__recordingsSection___QjJWOX",
  "vg": "CompanionRecords.module__speakerAvatar___QjJWOX",
  "CK": "CompanionRecords.module__roleEditor___QjJWOX",
  "eB": "CompanionRecords.module__transcriptTime___QjJWOX",
  "TQ": "CompanionRecords.module__searchEmpty___QjJWOX",
  "qV": "CompanionRecords.module__skeleton___QjJWOX",
  "US": "CompanionRecords.module__skeletonRow___QjJWOX",
  "SQ": "CompanionRecords.module__detailTopBar___QjJWOX",
  "sM": "CompanionRecords.module__detailDeleteActions___QjJWOX",
  "RU": "CompanionRecords.module__detailDeletePrompt___QjJWOX",
  "zr": "CompanionRecords.module__summaryCard___QjJWOX",
  "PL": "CompanionRecords.module__insightCard___QjJWOX",
  "MY": "CompanionRecords.module__cardHeader___QjJWOX",
  "gw": "CompanionRecords.module__cardTitleGroup___QjJWOX",
  "Ii": "CompanionRecords.module__cardTitleIcon___QjJWOX",
  "JJ": "CompanionRecords.module__cardTitle___QjJWOX",
  "Jo": "CompanionRecords.module__cardHeaderActions___QjJWOX",
  "D_": "CompanionRecords.module__summaryBody___QjJWOX",
  "O": "CompanionRecords.module__insightsGrid___QjJWOX",
  "Js": "CompanionRecords.module__bookmarkList___QjJWOX",
  "cf": "CompanionRecords.module__actionItemList___QjJWOX",
  "H4": "CompanionRecords.module__bookmarkCard___QjJWOX",
  "I$": "CompanionRecords.module__bookmarkMeta___QjJWOX",
  "qi": "CompanionRecords.module__bookmarkTime___QjJWOX",
  "$T": "CompanionRecords.module__bookmarkNote___QjJWOX",
  "Yl": "CompanionRecords.module__actionItemRow___QjJWOX",
  "pK": "CompanionRecords.module__actionItemMeta___QjJWOX",
  "oh": "CompanionRecords.module__actionItemDone___QjJWOX",
  "lw": "CompanionRecords.module__transcriptItemHighlighted___QjJWOX",
  "xp": "CompanionRecords.module__sessionSummaryPreview___QjJWOX",
  "V3": "CompanionRecords.module__multiTrackCard___QjJWOX",
  "VZ": "CompanionRecords.module__multiTrackControls___QjJWOX",
  "gb": "CompanionRecords.module__multiTrackSliderWrap___QjJWOX",
  "OO": "CompanionRecords.module__multiTrackTime___QjJWOX",
  "nP": "CompanionRecords.module__multiTrackTracks___QjJWOX",
};

module.exports = exports;
